// Content translations for dynamic content from ContentContext
export const contentTranslations = {
  // Slides translations
  slides: {
    'Ruang Investasi Sukoharjo': {
      en: 'Sukoharjo Investment Space'
    },
    'Gerbang Menuju Investasi yang Makmur dan Berkelanjutan': {
      en: 'Gateway to Prosperous and Sustainable Investment'
    },
    'Lokasi Strategis': {
      en: 'Strategic Location'
    },
    'Terhubung dengan Kota-kota Besar dan Jaringan Transportasi': {
      en: 'Connected to Major Cities and Transportation Networks'
    },
    'Ekonomi Berkembang': {
      en: 'Growing Economy'
    },
    'Sektor Industri dan Pertanian yang Berkembang Pesat': {
      en: 'Rapidly Developing Industrial and Agricultural Sectors'
    }
  },
  
  // Profile content translations
  profile: {
    'Profil Kabupaten Sukoharjo': {
      en: 'Sukoharjo Regency Profile'
    },
    'Kabupaten Sukoharjo adalah salah satu kabupaten di Provinsi Jawa Tengah yang terletak di bagian selatan Solo Raya. Dengan posisi strategis yang menghubungkan berbagai kota besar, Sukoharjo menjadi destinasi investasi yang menarik.': {
      en: 'Sukoharjo Regency is one of the regencies in Central Java Province located in the southern part of Greater Solo. With its strategic position connecting major cities, Sukoharjo becomes an attractive investment destination.'
    },
    'Mengapa Berinvestasi di Sukoharjo?': {
      en: 'Why Invest in Sukoharjo?'
    },
    'Temukan keunggulan dan peluang investasi yang menarik di Kabupaten Sukoharjo': {
      en: 'Discover the advantages and attractive investment opportunities in Sukoharjo Regency'
    }
  },

  // Profile advantages translations
  advantages: {
    'Lokasi Strategis': {
      en: 'Strategic Location'
    },
    'Terletak di jantung Jawa Tengah dengan akses mudah ke berbagai kota besar': {
      en: 'Located in the heart of Central Java with easy access to various major cities'
    },
    'Ekonomi Berkembang': {
      en: 'Growing Economy'
    },
    'Pertumbuhan ekonomi yang konsisten dengan berbagai sektor unggulan': {
      en: 'Consistent economic growth with various leading sectors'
    },
    'SDM Berkualitas': {
      en: 'Quality Human Resources'
    },
    'Sumber daya manusia yang terampil dan siap mendukung investasi Anda': {
      en: 'Skilled human resources ready to support your investment'
    },
    'Infrastruktur Modern': {
      en: 'Modern Infrastructure'
    },
    'Infrastruktur transportasi dan utilitas yang terus berkembang': {
      en: 'Continuously developing transportation and utility infrastructure'
    }
  },

  // Facilities translations
  facilities: {
    'Jalan Tol Solo-Sragen': {
      en: 'Solo-Sragen Toll Road'
    },
    'Akses jalan tol yang menghubungkan dengan berbagai kota': {
      en: 'Toll road access connecting to various cities'
    },
    'Transportasi': {
      en: 'Transportation'
    },
    'Bandara Internasional Adi Soemarmo': {
      en: 'Adi Soemarmo International Airport'
    },
    'Bandara internasional dengan berbagai rute domestik dan internasional': {
      en: 'International airport with various domestic and international routes'
    },
    'Stasiun Kereta Api': {
      en: 'Railway Station'
    },
    'Akses kereta api yang menghubungkan berbagai kota': {
      en: 'Railway access connecting various cities'
    },
    'Kawasan Industri Sukoharjo': {
      en: 'Sukoharjo Industrial Zone'
    },
    'Kawasan industri modern dengan fasilitas lengkap': {
      en: 'Modern industrial zone with complete facilities'
    },
    'Industri': {
      en: 'Industry'
    },
    'Fasilitas Pendidikan': {
      en: 'Educational Facilities'
    },
    'Sekolah dan universitas berkualitas untuk pengembangan SDM': {
      en: 'Quality schools and universities for human resource development'
    },
    'Pendidikan': {
      en: 'Education'
    },
    'Fasilitas Kesehatan': {
      en: 'Health Facilities'
    },
    'Rumah sakit dan klinik dengan standar pelayanan tinggi': {
      en: 'Hospitals and clinics with high service standards'
    },
    'Kesehatan': {
      en: 'Health'
    },
    'Infrastruktur Energi': {
      en: 'Energy Infrastructure'
    },
    'Suplai listrik dan energi yang stabil dan memadai': {
      en: 'Stable and adequate electricity and energy supply'
    },
    'Energi': {
      en: 'Energy'
    },
    'Jaringan Telekomunikasi': {
      en: 'Telecommunications Network'
    },
    'Konektivitas internet dan telekomunikasi yang handal': {
      en: 'Reliable internet and telecommunications connectivity'
    },
    'Telekomunikasi': {
      en: 'Telecommunications'
    },
    'Sumber Daya Manusia': {
      en: 'Human Resources'
    },
    'Tenaga kerja terampil dan siap pakai': {
      en: 'Skilled and ready-to-work workforce'
    },
    'SDM': {
      en: 'Human Resources'
    }
  },

  // Investment opportunities translations
  opportunities: {
    'Industri Gitar Baki': {
      en: 'Baki Guitar Industry'
    },
    'Pusat manufaktur gitar terkenal dunia dengan potensi ekspor yang besar': {
      en: 'World-renowned guitar manufacturing center with great export potential'
    },
    'Manufaktur': {
      en: 'Manufacturing'
    },
    'Kecamatan Baki': {
      en: 'Baki District'
    },
    'Industri Tekstil': {
      en: 'Textile Industry'
    },
    'Sektor manufaktur tekstil dan garmen yang berkembang pesat': {
      en: 'Rapidly developing textile and garment manufacturing sector'
    },
    'Tekstil': {
      en: 'Textile'
    },
    'Kawasan Industri': {
      en: 'Industrial Zone'
    },
    'Agroindustri': {
      en: 'Agro-industry'
    },
    'Pengolahan hasil pertanian dan perkebunan': {
      en: 'Processing of agricultural and plantation products'
    },
    'Pertanian': {
      en: 'Agriculture'
    },
    'Zona Pertanian': {
      en: 'Agricultural Zone'
    },
    'Industri Furniture': {
      en: 'Furniture Industry'
    },
    'Manufaktur mebel dan furniture berkualitas ekspor': {
      en: 'Manufacturing of export-quality furniture and furniture'
    },
    'Industri Otomotif': {
      en: 'Automotive Industry'
    },
    'Komponen dan suku cadang otomotif': {
      en: 'Automotive components and spare parts'
    },
    'Otomotif': {
      en: 'Automotive'
    },
    'Pariwisata': {
      en: 'Tourism'
    },
    'Pengembangan destinasi wisata dan hospitality': {
      en: 'Tourism destination and hospitality development'
    },
    'Area Wisata': {
      en: 'Tourism Area'
    }
  }
};

// Interface for multilingual text
interface MultilingualText {
  id: string;
  en: string;
}

// Helper function to get translated content
export const getContentTranslation = (text: string | MultilingualText, language: string): string => {
  // If it's already a MultilingualText object, use it directly
  if (typeof text === 'object' && text !== null && 'id' in text && 'en' in text) {
    return language === 'en' ? text.en : text.id;
  }
  
  // Legacy support for string-based text
  const textString = text as string;
  if (language === 'id') return textString; // Return Indonesian as-is

  // Search in all translation categories
  const categories = ['slides', 'profile', 'advantages', 'facilities', 'opportunities'];
  
  for (const category of categories) {
    const categoryTranslations = contentTranslations[category as keyof typeof contentTranslations];
    if (categoryTranslations && categoryTranslations[textString as keyof typeof categoryTranslations]) {
      return (categoryTranslations[textString as keyof typeof categoryTranslations] as any).en;
    }
  }
  
  // Return original text if no translation found
  return textString;
};
